module.exports = __webpack_public_path__ + "static/Oswald-Regular-f4549287e6d971844f502ffe0fd21352.woff2";